import PersonAdd from './PersonAdd';

export default PersonAdd;
